import { useQuery, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";

import { getFarmFootprintByYear } from "services";

import { getLocalKlimVar, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_FARM } from "consts";

export const useGetFootprintingFarmFootprint = (farmId?: string, year?: number, { enabled = true } = {}) => {
  const { user } = useUserContext();
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getLocalKlimVar("token");

  const enableQuery = (enabled && !!farmId && !!year && !!user && carbonProgram?.platformFeatures?.footprinting?.enabled && !!token) ?? false;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_FARM, farmId, year, carbonProgram?.platformFeatures?.footprinting?.enabled],
      queryFn: async () => getFarmFootprintByYear(year ?? 0),
      enabled: enableQuery,
      gcTime: 60000,
      retry: (_, error) => {
        if (!(error instanceof AxiosError)) return true;

        if (error.response?.status === 404 || error.response?.status === 418) return false;
        return true;
      },
    },
    queryClient
  );
};
